import React  from 'react';
import Flex from "../shared/Flex";
import citycadGreyIcon from "../../assets/images/icons/citycad-grey.png";
import citycadLogo from "../../assets/images/icons/logo_circle.png";

import TableRowContainer from "../shared/TableRowContainer";
import iconNavigateUp from "../../assets/images/icons/navigate_up.svg";
import iconNavigateDown from "../../assets/images/icons/navigate_down.svg";
import Badge from "../shared/Badge";
import { getLicenceColour } from "../../configuration";

class LicenceContainer extends React.Component {
  render() {
    return (
      <TableRowContainer onClick={() => this.props.toggleLicence(this.props.licence.id)}>
        <Flex>
          <div style={{width: "32px", marginRight: "10px"}}>
            <img src={this.props.licence.domainstatus === 'Active' ? citycadLogo : citycadGreyIcon} alt={`Citycad icon`} style={{maxWidth:"16px"}} />
          </div>
          <div style={{textAlign:"left"}}>
            {this.props.licence.ProductName} <Badge bold color={getLicenceColour(this.props.licence.domainstatus)}>{this.props.licence.domainstatus}</Badge><br />
            <small><strong>{this.props.licence.domain}</strong></small>
            {
              this.props.licence.isVisible
              &&
              <div>
                <hr />
                {
                  this.props.licence.AllowedActivations !== null
                  &&
                  <React.Fragment>
                    <span>
                      Current activations: {this.props.licence.CurrentActivations} ({this.props.licence.AllowedActivations - this.props.licence.CurrentActivations} remaining)<br />
                      Total allowed activations: {this.props.licence.AllowedActivations}<br />
                    </span>
                  </React.Fragment>
                }
                Licence status: {this.props.licence.domainstatus}<br />
                Registered: {this.props.licence.regdate}<br />
                {
                  (this.props.licence.domainstatus !== "Terminated" && this.props.licence.nextduedate !== "0000-00-00")
                  &&
                  <span>Next due date: {this.props.licence.nextduedate}</span>
                }
                {
                  (this.props.licence.domainstatus === "Active" && this.props.licence.nextduedate === "0000-00-00")
                  &&
                  <span>Next due date: N/A</span>
                }
              </div>
            }
          </div>
        </Flex>
        <div style={{minWidth:"60px"}}>

        </div>
        <div style={{width:"32px"}}>
          {
            this.props.licence.isVisible
              ?
              <img src={iconNavigateUp} alt={`Up`} style={{width: "10px", height: "13px"}} />
              :
              <img src={iconNavigateDown} alt={`Down`} style={{width: "10px", height: "13px"}} />
          }
        </div>
      </TableRowContainer>
    )
  }
}

export default LicenceContainer;



// {/*<LicenceContainerStyled domainstatus={this.props.licence.domainstatus}>*/}
// {/*  <LicenceTableCell>*/}
// {/*    {this.props.licence.domain}*/}
// {/*  </LicenceTableCell>*/}
// {/*  <LicenceTableCell>*/}
// {/*    {this.props.licence.ProductName} ({this.props.licence.domainstatus})*/}
// {/*  </LicenceTableCell>*/}
// {/*  <LicenceTableCell>*/}
// {/*    {*/}
// {/*      this.props.licence.AllowedActivations !== null*/}
// {/*      &&*/}
// {/*      <div>*/}
// {/*        <Computer size={16} /> {this.props.licence.CurrentActivations}/{this.props.licence.AllowedActivations}*/}
// {/*      </div>*/}
// {/*    }*/}
// {/*  </LicenceTableCell>*/}
//
//
// {/*<div style={{width: "32px", marginRight: "10px"}}>*/}
// {/*  <TicketAlt size={16} />*/}
// {/*</div>*/}
// {/*  <div>*/}
// {/*    {this.props.licence.ProductName} ({this.props.licence.domainstatus})<br />*/}
// {/*    Licence key: {this.props.licence.domain}<br />*/}
// {/*  </div>*/}
// {/*</td>*/}
// {/*<div>*/}
// {/*  {*/}
// {/*    this.props.licence.AllowedActivations !== null*/}
// {/*    &&*/}
// {/*    <div>*/}
// {/*      <Computer size={16} /> {this.props.licence.CurrentActivations}/{this.props.licence.AllowedActivations}*/}
// {/*    </div>*/}
// {/*  }*/}
// {/*</div>*/}
